<template>

    <el-row id="custom" style="height: 100%;">


        <el-col :span="8" style="background: white;width: 400px;height:auto;">
            <el-row type="flex" justify="center" style="height: 30px">
                <el-col :span="24">
                    <el-col :span="24" style="text-align: end;">
                        <span  style="font-size: 19px;float: left;line-height: 30px;font-weight: bold">支持自定义字段的表</span>
                                                <el-button type="success" style="background: #4EC880" icon="el-icon-plus" size="small"
                                                           @click="open3">新增表
                                                </el-button>
                    </el-col>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="height: calc(100% - 42px);margin-bottom: 0">
                <el-col :span="24" style="height: auto;border: 1px solid #eee;">
                    <div style="padding: 10px;">
                        <el-input
                                class="sWei"
                                placeholder="请输入表名称进行快速检索"
                                v-model="filterText">
                        </el-input>
                    </div>
                    <!--:class="$style.scrollbar"-->


                        <el-tree
                                class="filter-tree"
                                :data="data"
                                @node-click="handleNodeClick"
                                :props="defaultProps"
                                node-key="define_id"
                                :highlight-current="true"
                                :filter-node-method="filterNode"
                                :default-expanded-keys="[2000]"
                                ref="tree">
                        </el-tree>

                </el-col>
            </el-row>
        </el-col>
        <el-col :span="16" class="StoCen" style="height: 100%;overflow: auto;">
            <el-row style="height: 20px;margin-top: 4px" type="flex" align="middle">
                <el-col :span="3" style="font-size: 17px;font-weight: bold">表名</el-col>
                <el-col :span="14" style="color: #409EFF;font-size: 17px;font-weight: bold">{{schTitle1}}</el-col>
                <!--                <el-col :span="3" :push="9" >-->
                <!--                    <el-button type="text" @click="open4"-->
                <!--                               :style="{color: updataActive?'#F8A929':'#eee',float:'right'}"-->
                <!--                               style="font-size: 17px;font-weight: bold" id="el-button">编辑-->
                <!--                    </el-button>-->
                <!--                </el-col>-->

            </el-row>
            <el-row class="xux"></el-row>
            <!--                        <el-row v-for="(item,index) in valueArr" :key="index" style="font-size: 12px;height: auto">-->
            <!--                        说明{{index+1}}:{{item}}-->
            <!--                    </el-row>-->

            <el-row v-if="addGrp">
                <el-col :span="24" style="float: left">
                    <el-button type="success" style="background: #4EC880;border: none" icon="el-icon-plus" size="small"
                               @click="addGroupList">添加组</el-button>
                </el-col>
            </el-row>

            <el-tabs v-model="activeNameGroup" @tab-click="handleClick">
                <el-tab-pane
                        :label="item.group_name"
                        :name="item.group_id"
                        v-for="(item,index) in groupList"
                        :key="index">
                    <el-row type="flex" align="middle">
                        <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px ">字段数：{{fieldsList.length}}个</el-col>
                        <el-col :span="8" style="text-align: end;">
                            <el-button type="success" style="background:#FF9901;border: none"  size="small"
                                       @click="uploadGroupList(item)">编辑字段组</el-button>
                            <el-button type="success" style="background: #4EC880;border: none" icon="el-icon-plus" size="small"
                                       @click="addListOpen(item)">添加字段</el-button>
                        </el-col>
                    </el-row>
                    <el-col>
                        <el-table :data="fieldsList" stripe style="width: 100%" border @row-click="myRowClick" :header-cell-style="{'color':'black'}">
                            <el-table-column prop="field_name" label="字段名" sortable class="Tnumber" fixed="left" width="200"></el-table-column>
                            <el-table-column prop="input_type" label="数据类型" width="110" sortable></el-table-column>
                            <el-table-column prop="label" label="显示名称"  sortable></el-table-column>
                            <el-table-column prop="status" label="状态" width="100" sortable></el-table-column>
                            <el-table-column label="操作" label-class-name="custom_table_cell" fixed="right" width="80">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini" @click="myDetails(scope.$index, scope.row)">编辑</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-tab-pane>

            </el-tabs>
        </el-col>

        <!--添加组-->
        <el-dialog title="" :visible.sync="addGroupoptions">
            <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                <span style="color: #3998F7;font-size: 22px">添加组</span>
                <span>
                <el-button @click="addJudge" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="aboGroup" size="small">取消</el-button>
                </span>

            </div>
            <el-form ref="addGroupForm" :model="addGroupForm" label-width="90px" style="margin-left:80px"  id="addGroup" hide-required-asterisk>
                <el-row>
                    <el-col :span="24" >
                        <el-form-item label="表名" >
                            <P style="margin:0;color: #3b99f7;font-size: 14px;width: 100%;height:40px;overflow: hidden;">{{addGroupForm.table_name}}</P>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="组名" prop="group_name" class="custom_star" :rules="[
                                           { required: true, message: '组名不能为空'},]">
                            <el-input v-model="addGroupForm.group_name" placeholder="请填写组名" style="width: 80%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="排序值" prop="sort" class="custom_star" :rules="[
                                           { required: true, message: '排序值不能为空'},]">
                            <el-input v-model="addGroupForm.sort" style="width: 80%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="说明">
                            <el-input v-model="addGroupForm.comments" type="textarea"
                                      :rows="2"
                                      placeholder="请填写说明" style="width: 80%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="启用" >
                            <el-switch v-model="addGroupForm.status"
                                       active-color="#13ce66"
                                       active-value="ACTIVE"
                                       inactive-value = "INACTIVE">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>

        </el-dialog>
        <!--新增表-->
        <el-dialog title="" :visible.sync="dialogFormVisible" id="add">
            <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                <span style="color: #3998F7;font-size: 22px">添加表</span>
                <span>
                <el-button @click="addTable" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="abolish" size="small">取消</el-button>
                </span>

            </div>
            <el-form :model="addTableForm"  ref="ruleForm1" class="demo-ruleForm" hide-required-asterisk>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="表名" label-width="80px" style="margin-left: 80px;" prop="table_name" class="custom_star" :rules="[
                                           { required: true, message: '表名不能为空'},
                                    ]">
                            <el-input type="text" v-model="addTableForm.table_name" style="width: 80%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="类型" label-width="80px" style="margin-left: 80px;" prop="table_type" class="custom_star" :rules="[
                                           { required: true, message: '类型不能为空'},
                                    ]">
                            <el-select v-model="addTableForm.table_type" placeholder="请选择类型" style="width: 80%" clearable>
                                <el-option
                                        v-for="item in tableTypeOptions"
                                        :key="item.field_type"
                                        :label="item.type_name"
                                        :value="item.field_type">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="启用" label-width="80px" style="margin-left: 80px;" >
                            <el-switch v-model="addTableForm.status" active-color="#13ce66"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="说明" label-width="80px" style="margin-left: 80px;">
                            <el-input
                                    type="textarea"
                                    placeholder="请输入内容"
                                    v-model="addTableForm.comments"
                                    maxlength="30"
                                    show-word-limit
                                    style="width: 80%"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
        </el-dialog>

        <!--添加字段-->
        <el-dialog title="" :visible.sync="dialogFormVisible3">
            <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                <span style="color: #3998F7;font-size: 22px">添加字段</span>
                <span>
                <el-button @click="add" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="abolish1" size="small">取消</el-button>
                </span>

            </div>
            <el-form :model="addListForm"  ref="ruleForm3" class="demo-ruleForm" hide-required-asterisk>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="字段组" label-width="100px" prop="group_id" class="custom_star" :rules="[
                                           { required: true, message: '字段组不能为空'},
                                    ]">
                            <el-select v-model="addListForm.group_id" placeholder="请选择字段组" @change="getSort" style="width: 100%" clearable>
                                <el-option
                                        v-for="item in groupIdList"
                                        :key="item.group_id"
                                        :label="item.group_name"
                                        :value="item.group_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="字段名" style="margin-left:20px;" label-width="100px" class="custom_star" prop="field_name" :rules="[
                                           { required: true, message: '字段名不能为空'},
                                    ]">
                            <el-input type="text" v-model="addListForm.field_name" placeholder="请输入字段名称" @input="addLabel"></el-input>
                        </el-form-item>
                    </el-col>
<!--                    <el-col :span="12" >-->
<!--                        <el-form-item label="上级字段" label-width="100px" style="margin-left:20px;">-->
<!--                            <el-select v-model="addListForm.parent_field" placeholder="请选择上级字段" style="width: 100%" clearable>-->
<!--                                <el-option-->
<!--                                        v-for="item in fieldOptions"-->
<!--                                        :key="item.field_id"-->
<!--                                        :label="item.field_name"-->
<!--                                        :value="item.field_id">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                    <el-col :span="12">
                        <el-form-item label="显示名称" label-width="100px" prop="label" class="custom_star" :rules="[
                                           { required: true, message: '显示名称不能为空'},
                                    ]">
                            <el-input type="text" v-model="addListForm.label" placeholder="请输入字段显示名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="字段类型" label-width="100px" style="margin-left:20px;">
                            <el-select v-model="addListForm.field_type" placeholder="请选择字段类型" style="width: 100%" clearable>
                                <el-option
                                        v-for="item in fieldTypeOptions"
                                        :key="item.field_type"
                                        :label="item.type_name"
                                        :value="item.field_type">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="数据类型" label-width="100px" prop="data_type" class="custom_star" :rules="[
                                           { required: true, message: '数据类型不能为空'},
                                    ]">
                            <el-select v-model="addListForm.data_type" placeholder="请选择数据类型" style="width: 100%" clearable>
                                <el-option
                                        v-for="item in dataOptions"
                                        :key="item.data_type"
                                        :label="item.type_name"
                                        :value="item.data_type">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="UI类型" label-width="100px" style="margin-left:20px;" prop="input_type" class="custom_star" :rules="[
                                           { required: true, message: 'UI类型不能为空'},
                                    ]">
                            <el-select v-model="addListForm.input_type" placeholder="请选择UI类型" style="width: 100%" clearable>
                                <el-option
                                        v-for="item in UiOptions"
                                        :key="item.ui_type"
                                        :label="item.input_name"
                                        :value="item.ui_type">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="绑定字典" label-width="100px" >
<!--                            <el-select v-model="addListForm.dictionary" placeholder="请选择数据字典" style="width: 100%;" clearable>-->
<!--                                <el-option-->
<!--                                        v-for="item in dictionaryList"-->
<!--                                        :key="item.category"-->
<!--                                        :label="item.name"-->
<!--                                        :value="item.category">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
                            <el-cascader
                                    v-model="addListForm.dictionary"
                                    v-if="isShowAddressInfo"
                                    :options="dictionaryList"
                                    style="width: 100%"
                                    filterable
                                    :show-all-levels="false"
                                    :props="{ checkStrictly: true }"
                                    clearable></el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="日期数组列" style="margin-left:20px;" label-width="100px" >
                            <el-select v-model="addListForm.array_date" placeholder="请选择日期数组列" style="width: 100%;" clearable>
                                <el-option
                                        v-for="item in dateArray"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="产品数组列"  label-width="100px" >
                            <el-select v-model="addListForm.array_product" placeholder="请选择产品数组列" style="width: 100%;" clearable>
                                <el-option
                                        v-for="item in productArray"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="科室数组列" style="margin-left:20px;" label-width="100px" >
                            <el-select v-model="addListForm.array_dept" placeholder="请选择科室数组列" style="width: 100%;" clearable>
                                <el-option
                                        v-for="item in deptArray"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="排序值" label-width="100px"  prop="sort" class="custom_star" :rules="[
                                           { required: true, message: '排序值不能为空'},
                                    ]">
                            <el-input type="number" v-model="addListForm.sort" style="width:calc( 50% - 50px);" :maxlength="200"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="允许多选" label-width="100px" >
                            <el-switch v-model="addListForm.multiple" active-color="#13ce66"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="必填字段" label-width="100px" style="margin-left:20px;">
                            <el-switch v-model="addListForm.mandatory" active-color="#13ce66"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="只读字段" label-width="100px" >
                            <el-switch v-model="addListForm.readonly" active-color="#13ce66"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="隐藏字段" label-width="100px" style="margin-left:20px;">
                            <el-switch v-model="addListForm.hidden" active-color="#13ce66"></el-switch>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24" >
                        <el-form-item label="字段说明" label-width="100px" >
                            <el-input
                                    type="textarea"
                                    placeholder="请输入字段说明"
                                    v-model="addListForm.comments"
                                    maxlength="30"
                                    rows="4"
                                    show-word-limit
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="启用" label-width="100px" >
                            <el-switch v-model="addListForm.status" active-color="#13ce66"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
        </el-dialog>

        <!--编辑字段-->
        <el-dialog title="" :visible.sync="dialogFormVisible4">
            <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                <span style="color: #3998F7;font-size: 22px">编辑字段</span>
                <span>
                <el-button @click="upDate" type="primary" size="small">保 存</el-button>
                <el-button type="danger" @click="abolish2" size="small">取 消</el-button>
                </span>

            </div>
            <el-form :model="updataListForm" ref="ruleForm4" class="demo-ruleForm" hide-required-asterisk>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="字段组" label-width="100px" prop="group_id" class="custom_star" :rules="[
                                           { required: true, message: '字段组不能为空'},
                                    ]">
                            <el-select v-model="updataListForm.group_id" placeholder="请选择字段组" @change="getSort" style="width: 100%" clearable>
                                <el-option
                                        v-for="item in groupIdList"
                                        :key="item.group_id"
                                        :label="item.group_name"
                                        :value="item.group_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="字段名" label-width="100px" style="margin-left:20px;">
                            <el-input type="text" v-model="updataListForm.field_name" disabled></el-input>
                        </el-form-item>
                    </el-col>
<!--                    <el-col :span="12" >-->
<!--                        <el-form-item label="上级字段" label-width="100px" style="margin-left:20px;">-->
<!--                            <el-select v-model="updataListForm.parent_field" placeholder="请选择上级字段" style="width: 100%" clearable>-->
<!--                                <el-option-->
<!--                                        v-for="item in fieldOptions"-->
<!--                                        :key="item.field_id"-->
<!--                                        :label="item.field_name"-->
<!--                                        :value="item.field_id">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                    <el-col :span="12">
                        <el-form-item label="显示名称" label-width="100px" prop="label" class="custom_star" :rules="[
                                           { required: true, message: '显示名称不能为空'},
                                    ]">
                            <el-input type="text" v-model="updataListForm.label"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="字段类型" label-width="100px" style="margin-left:20px;">
                            <el-select v-model="updataListForm.field_type" placeholder="请选择字段类型" style="width: 100%" clearable>
                                <el-option
                                        v-for="item in fieldTypeOptions"
                                        :key="item.field_type"
                                        :label="item.type_name"
                                        :value="item.field_type">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="数据类型" label-width="100px" prop="data_type" class="custom_star" :rules="[
                                           { required: true, message: '数据类型不能为空'},
                                    ]">
                            <el-select v-model="updataListForm.data_type" placeholder="请选择数据类型" style="width: 100%" clearable>
                                <el-option
                                        v-for="item in dataOptions"
                                        :key="item.data_type"
                                        :label="item.type_name"
                                        :value="item.data_type">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="UI类型" label-width="100px" style="margin-left:20px;" prop="input_type" class="custom_star" :rules="[
                                           { required: true, message: 'UI类型不能为空'},
                                    ]">
                            <el-select v-model="updataListForm.input_type" placeholder="请选择UI类型" style="width: 100%" clearable>
                                <el-option
                                        v-for="item in UiOptions"
                                        :key="item.ui_type"
                                        :label="item.input_name"
                                        :value="item.ui_type">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="绑定字典" label-width="100px" >
<!--                            <el-select v-model="updataListForm.dictionary" placeholder="请选择数据字典" style="width: 100%;" clearable>-->
<!--                                <el-option-->
<!--                                        v-for="item in dictionaryList"-->
<!--                                        :key="item.category"-->
<!--                                        :label="item.name"-->
<!--                                        :value="item.category">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
                            <el-cascader
                                    v-model="updataListForm.dictionary"
                                    v-if="isShowAddress"
                                    :options="dictionaryList"
                                    filterable
                                    style="width: 100%"
                                    :props="{ checkStrictly: true }"
                                    :show-all-levels="false"
                                    clearable></el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="日期数组列" style="margin-left:20px;" label-width="100px" >
                            <el-select v-model="updataListForm.array_date" placeholder="请选择日期数组列" style="width: 100%;" clearable>
                                <el-option
                                        v-for="item in dateArray"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="产品数组列"  label-width="100px" >
                            <el-select v-model="updataListForm.array_product" placeholder="请选择产品数组列" style="width: 100%;" clearable>
                                <el-option
                                        v-for="item in productArray"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="科室数组列" style="margin-left:20px;" label-width="100px" >
                            <el-select v-model="updataListForm.array_dept" placeholder="请选择科室数组列" style="width: 100%;" clearable>
                                <el-option
                                        v-for="item in deptArray"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="排序值" label-width="100px"  prop="sort" class="custom_star" :rules="[
                                           { required: true, message: '排序值不能为空'},
                                    ]">
                            <el-input type="number" v-model="updataListForm.sort" style="width:calc( 50% - 50px);" :maxlength="200"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="允许多选" label-width="100px" >
                            <el-switch v-model="updataListForm.multiple" active-color="#13ce66"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="必填字段" label-width="100px" style="margin-left:20px;">
                            <el-switch v-model="updataListForm.mandatory" active-color="#13ce66"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="只读字段" label-width="100px" >
                            <el-switch v-model="updataListForm.readonly" active-color="#13ce66"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="隐藏字段" label-width="100px" style="margin-left:20px;">
                            <el-switch v-model="updataListForm.hidden" active-color="#13ce66"></el-switch>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24" >
                        <el-form-item label="字段说明" label-width="100px" >
                            <el-input
                                    type="textarea"
                                    placeholder="请输入字段说明"
                                    v-model="updataListForm.comments"
                                    maxlength="30"
                                    rows="4"
                                    show-word-limit
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="启用" label-width="100px" >
                            <el-switch v-model="updataListForm.status" active-color="#13ce66"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <!--编辑组-->
        <el-dialog title="" :visible.sync="uploadGroupoptions" >
            <div slot="title"  style="display: flex;justify-content:space-between">
                <span style="color: #3998F7;font-size: 22px">编辑字段组</span>
                <span>
                <el-button @click="uploadJudge" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="uploadGroup" size="small">取消</el-button>
                </span>

            </div>
            <el-form ref="uploadGroupForm" style="margin-left: 80px" :model="uploadGroupForm" label-width="90px"  id="uploadGroup" hide-required-asterisk>
                <el-row>
                    <el-col :span="24" >
                        <el-form-item label="表名" >
                            <P style="margin:0;color: #3b99f7;font-size: 14px;width: 100%;height:40px;overflow: hidden;">{{uploadGroupForm.table_name}}</P>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="组名" prop="group_name" class="custom_star" :rules="[
                                           { required: true, message: '组名不能为空'},]">
                            <el-input v-model="uploadGroupForm.group_name" placeholder="请填写组名" style="width: 80%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="排序值" prop="sort" class="custom_star" :rules="[
                                           { required: true, message: '排序值不能为空'},]">
                            <el-input v-model="uploadGroupForm.sort" style="width: 80%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="说明">
                            <el-input v-model="uploadGroupForm.comments" type="textarea"
                                      :rows="2"
                                      placeholder="请填写说明" style="width: 80%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="启用" >
                            <el-switch v-model="uploadGroupForm.status"
                                       active-color="#13ce66"
                                       active-value="ACTIVE"
                                       inactive-value = "INACTIVE">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>

        </el-dialog>

    </el-row>
</template>

<script>
    import http from '../../../APIService/http'
    import { MessageBox, Message } from 'element-ui';
    let number=1

    export default {
        name: "Main",
        data() {

            return {
                fieldsList:[],
                activeNameGroup:'',
                addGroupoptions:false,
                addGrp:false,
                addGroupForm:{
                    table_id:'',
                    table_name:'',
                    group_name:'',
                    sort:1,
                    comments:'',
                    status:'ACTIVE'
                },
                groupList:[],
                table_id:'',
                groupIdList:[],
                dateArray:[
                    {
                        id:'NONE',
                        value:'禁用'
                    },{
                        id:'YEAR',
                        value:'年'
                    },{
                        id:'QUARTER',
                        value:'季度'
                    },{
                        id:'MONTH',
                        value:'月'
                    },{
                        id:'WEEK',
                        value:'周'
                    },{
                        id:'DAY',
                        value:'日'
                    },
                ],
                productArray:[
                    {
                        id:'NONE',
                        value:'禁用'
                    },{
                        id:'PRODUCT',
                        value:'产品'
                    },{
                        id:'SKU',
                        value:'SKU'
                    },
                ],
                deptArray:[
                    {
                        id:'NONE',
                        value:'禁用'
                    },{
                        id:'STANDARD_DEPT',
                        value:'标准科室'
                    },
                ],
                isShowAddressInfo:false,
                isShowAddress:false,
                openOff:true,
                lastSort:'',
                fieldOptions:[],
                superior_field:'',
                dictionaryList:[],
                fieldTypeOptions:[
                    {
                        field_type:'VIRTUAL',
                        type_name:'虚拟字段'
                    },
                    {
                        field_type:'PHYSICAL',
                        type_name:'实体字段'
                    }
                ],
                tableTypeOptions:[
                    {
                        field_type:'VIRTUAL',
                        type_name:'虚拟表'
                    },
                    {
                        field_type:'PHYSICAL',
                        type_name:'实体表'
                    }
                ],
                dataOptions:[
                    {
                        data_type:'VARCHAR',
                        type_name:'VARCHAR'
                    },
                    {
                        data_type:'NUMBER',
                        type_name:'NUMBER'
                    },
                    {
                        data_type:'DATE',
                        type_name:'DATE'
                    },
                    {
                        data_type:'TRUE-FALSE',
                        type_name:'TRUE-FALSE'
                    },
                    {
                        data_type:'ARRAY',
                        type_name:'ARRAY'
                    },

                ],
                UiOptions:[
                    {
                        ui_type:'TEXT',
                        input_name:'文本型'
                    },
                    {
                        ui_type:'NUMBER',
                        input_name:'数字型'
                    },
                    {
                        ui_type:'DATE',
                        input_name:'日期型'
                    },
                    {
                        ui_type:'TRUE-FALSE',
                        input_name:'逻辑型'
                    },
                    {
                        ui_type:'LIST',
                        input_name:'选项型'
                    },
                    {
                        ui_type:'COMMENTS',
                        input_name:'说明型'
                    },
                    {
                        ui_type:'TABLE',
                        input_name:'表格型'
                    },
                ],
                addUserDis:true,
                listDate:{
                    dictionary_id:'',
                    tenant_id:''
                },
                MyData:'',
                define_id:'',
                len:0,
                len2:0,
                updataActive:'',
                stateNum:1,
                optionsNum:1,
                form:{
                    category:'',
                    name:'',
                    value1:'',
                    status:true
                },
                upForm:{
                    category:'',
                    name:'',
                    status:true
                },
                valueArr:[],
                addTableForm:{
                    table_name:'',
                    table_type:'',
                    status:true,
                    comments:''
                },
                group_id:'',
                addListForm:{
                    group_id:'',
                    array_date:'',
                    array_product:'',
                    array_dept:'',
                    field_name:'',
                    parent_field:'',
                    label:'',
                    field_type:'',
                    data_type:'',
                    input_type:'',
                    dictionary:'',
                    multiple:false,
                    mandatory:false,
                    readonly:false,
                    hidden:false,
                    sort:'',
                    comments:'',
                    status:true
                },
                updataListForm:{
                    group_id:'',
                    array_date:'',
                    array_product:'',
                    array_dept:'',
                    field_name:'',
                    parent_field:'',
                    label:'',
                    field_type:'',
                    data_type:'',
                    input_type:'',
                    dictionary:'',
                    multiple:false,
                    mandatory:false,
                    readonly:false,
                    hidden:false,
                    sort:'',
                    comments:'',
                    status:true
                },
                dialogFormVisible:false,
                dialogFormVisible2:false,
                dialogFormVisible3:false,
                dialogFormVisible4:false,
                uploadGroupoptions:false,
                folderId:null,
                folderName:null,
                num:{
                    sum:0,
                },
                uploadGroupForm:{
                    table_id:'',
                    table_name:'',
                    group_name:'',
                    group_id:'',
                    sort:1,
                    comments:'',
                    status:'ACTIVE'
                },
                myactive1:false,
                myactive2:false,
                schTitle1:"",
                treeKey:"",
                //表格数据
                tableData: [
                    /*{
                        date: '2016-05-02',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1518 弄'
                    }, {
                        date: '2016-05-04',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1517 弄'
                    }, {
                        date: '2016-05-01',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1519 弄'
                    }, {
                        date: '2016-05-03',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1516 弄'
                    }*/
                ],
                filterText: '',
                compileDic:{
                    category:'',
                    old_category:'',
                    tenant_id:'',
                    define_id:''
                },
                data: [/*{
          id: 1,
          label: '一级 1'

        }, {
          id: 2,
          label: '一级 2',
        }, {
          id: 3,
          label: '一级 3',
        }, {
          id: 4,
          label: '一级 4',
        } ,{
          id: 5,
          label: '一级 5',
        }*/],
                defaultProps: {
                    label: 'label'
                }
            }
        },
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            }
        },
        created () {

            this.getLibrary();



        },

        methods:{
            handleClick(tab, event){
                this.fieldsList = []
                this.group_id = tab.name
                this.getFieldsList()
            },
            getFieldsList(){

                let user = this.$store.getters.getUser
                let data = {
                    tenant_id:user.tenant_id,
                    table_id:this.table_id,
                    group_id:this.group_id
                }
                http.post('/wapi/v1/getFieldsList',data).then(res=>{
                    if(res.success){
                        this.fieldsList = res.data
                    }
                })
            },
            addLabel(e){
                this.addListForm.label = e
            },
            getSort(e){
                if(this.groupList.length>1){
                    for(let i = 0;i<this.groupList.length;i++){
                        if(this.groupList[i].group_id == e){
                            if(this.groupList[i].fieldsList.length>0){
                                this.addListForm.sort = this.groupList[i].fieldsList[this.groupList[i].fieldsList.length -1].sort + 1
                                this.updataListForm.sort = this.groupList[i].fieldsList[this.groupList[i].fieldsList.length -1].sort + 1
                            }else{
                                this.addListForm.sort = 1
                                this.updataListForm.sort = 1
                            }

                        }
                    }
                }else{
                    if(this.groupList[0].fieldsList.length>0){
                        this.addListForm.sort = this.groupList[0].fieldsList[this.groupList[0].fieldsList.length -1].sort + 1
                        this.updataListForm.sort = this.groupList[0].fieldsList[this.groupList[0].fieldsList.length -1].sort + 1
                    }else{
                        this.addListForm.sort = 1
                        this.updataListForm.sort = 1
                    }

                }

            },

            async getGroupList(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id:user.tenant_id,
                        table_id:this.table_id,
                    }
                    await http.post('/wapi/v1/getGroupList',data).then(res=>{
                        if(res.success){
                            this.groupList = []
                            this.groupList = res.data
                            let array = JSON.parse(JSON.stringify(this.groupList))
                            for(let i =0;i<array.length;i++){
                                if(array[i].group_name == '未分组'){
                                    this.groupIdList = array.splice(0,this.groupList.length - 1)
                                }else{
                                    this.groupIdList = array
                                }
                            }

                            if(this.group_id){
                                this.activeNameGroup = this.group_id
                            }else{
                                this.group_id = this.groupList[0].group_id
                                this.activeNameGroup = this.groupList[0].group_id
                            }
                            this.getFieldsList()
                            loading.close()
                        }
                    })
                }catch (e) {
                    loading.close()
                }

            },
            addGroupList(){
                this.addGroupForm.group_name=''
                if(this.groupList.length == 0){
                    this.addGroupForm.sort=1
                }else if(this.groupList.length == 1){
                    for(let i = 0;i<this.groupList.length;i++){
                        if(this.groupList[i].group_name == '未分组'){
                            this.addGroupForm.sort=1
                        }else{
                            this.addGroupForm.sort=2
                        }
                    }
                }else if(this.groupList.length > 1){
                    for(let i = 0;i<this.groupList.length;i++){
                        if(this.groupList[i].group_name == '未分组'){
                            this.addGroupForm.sort=this.groupList[this.groupList.length - 2].sort + 1
                        }else{
                            this.addGroupForm.sort=this.groupList[this.groupList.length - 1].sort + 1
                        }
                    }
                }

                this.addGroupForm.comments='',
                    this.addGroupForm.status='ACTIVE'
                this.addGroupoptions = true
            },
            addJudge(){
                this.$refs["addGroupForm"].validate(valid=>{
                    if(!valid){
                        return false
                    }else {
                        this.addGroup()
                    }
                })
            },
            addGroup(){
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id:user.tenant_id,
                    table_id:this.addGroupForm.table_id,
                    group_name:this.addGroupForm.group_name,
                    sort:this.addGroupForm.sort,
                    status:this.addGroupForm.status,
                    comments:this.addGroupForm.comments
                }
                http.post('/wapi/v1/addGroup',data).then(res=>{
                    if(res.success){
                        Message({
                            type: 'success',
                            message: '保存成功'
                        });
                        this.getGroupList()
                        this.$refs['addGroupForm'].resetFields();
                        this.addGroupoptions = false
                    }
                })

            },
            aboGroup(){
                this.addGroupoptions = false
            },
            upDate(){
                this.isShowAddress = false
                this.$refs["ruleForm4"].validate(valid=>{
                    if(!valid){
                        return false
                    }else {
                        this.upDateCustom()
                    }
                })
            },


            //编辑列表
            async upDateCustom() {


                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    if(this.updataListForm.input_type =='文本型'){
                        this.updataListForm.input_type = 'TEXT'
                    }else if(this.updataListForm.input_type =='数字型'){
                        this.updataListForm.input_type = 'NUMBER'
                    }else if(this.updataListForm.input_type =='日期型'){
                        this.updataListForm.input_type = 'DATE'
                    }else if(this.updataListForm.input_type =='逻辑型'){
                        this.updataListForm.input_type = 'TRUE-FALSE'
                    }else if(this.updataListForm.input_type =='选项型'){
                        this.updataListForm.input_type = 'LIST'
                    }else if(this.updataListForm.input_type =='说明型'){
                        this.updataListForm.input_type = 'COMMENTS'
                    }
                    if(this.updataListForm.dictionary[0] == 'undefined'){
                        this.updataListForm.dictionary = ''
                    }
                    let data={
                        tenant_id : this.updataListForm.tenant_id,
                        table_id : this.updataListForm.table_id,
                        field_id : this.updataListForm.field_id,
                        field_name:this.updataListForm.field_name,
                        parent_field:this.updataListForm.parent_field,
                        label:this.updataListForm.label,
                        field_type:this.updataListForm.field_type,
                        group_id:this.updataListForm.group_id,
                        array_date:this.updataListForm.array_date,
                        array_product:this.updataListForm.array_product,
                        array_dept:this.updataListForm.array_dept,
                        data_type:this.updataListForm.data_type,
                        input_type:this.updataListForm.input_type,
                        dictionary:this.updataListForm.dictionary,
                        multiple:this.updataListForm.multiple ? 'T':'F',
                        mandatory:this.updataListForm.mandatory ? 'T':'F',
                        readonly:this.updataListForm.readonly ? 'T':'F',
                        hidden:this.updataListForm.hidden ? 'T':'F',
                        sort:this.updataListForm.sort,
                        comments:this.updataListForm.comments,
                        status:this.updataListForm.status ? 'ACTIVE':'INACTIVE'
                    }
                    console.log(data)


                        await http.post('/wapi/v1/upDateCustom', data).then(res => {

                            loading.close()
                            if (res.success){
                                Message({
                                    type: 'success',
                                    message: '保存成功'
                                });
                                this.dialogFormVisible4 = false
                                // this.getcustomList(this.MyData)
                                this.getFieldsList()
                            }else{
                                Message.error('保存失败');

                            }
                        })



                } catch (err) {
                    loading.close()
                    console.log(`error:${err}`)
                }
            },
            addTable(){
                this.$refs["ruleForm1"].validate(valid=>{
                    if(!valid){
                        return false
                    }else {
                        this.addCustomTable()
                    }
                })
            },
            // 新增表
            async addCustomTable(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        table_name:this.addTableForm.table_name,
                        table_type:this.addTableForm.table_type,
                        comments:this.addTableForm.comments,
                        status:this.addTableForm.status ? 'ACTIVE':'INACTIVE'
                    }
                    console.log(data)

                    await http.post('/wapi/v1/addTableList', data).then(res => {

                        loading.close()
                        if (res.success){
                            this.dialogFormVisible = false
                            this.addTableForm.status = true
                            // this.getcustomList(this.MyData)
                            this.getLibrary()
                            Message({
                                type: 'success',
                                message: '保存成功'
                            });
                        }else {
                            Message.error('保存失败');

                        }
                    })

                } catch (err) {
                    loading.close()
                    console.log(`error:${err}`)
                }
            },
            add(){
                this.isShowAddressInfo = false
                this.$refs["ruleForm3"].validate(valid=>{
                    if(!valid){
                        return false
                    }else {
                        this.addCustom()
                    }
                })
            },
            uploadJudge(){
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id:user.tenant_id,
                    table_id:this.uploadGroupForm.table_id,
                    group_name:this.uploadGroupForm.group_name,
                    group_id:this.uploadGroupForm.group_id,
                    sort:this.uploadGroupForm.sort,
                    status:this.uploadGroupForm.status,
                    comments:this.uploadGroupForm.comments
                }
                http.post('/wapi/v1/upDateGroup',data).then(res=>{
                    if(res.success){
                        Message({
                            type: 'success',
                            message: '保存成功'
                        });
                        this.getGroupList()
                        this.$refs['uploadGroupForm'].resetFields();
                        this.uploadGroupoptions = false
                    }
                })

            },
            uploadGroup(){
                this.uploadGroupoptions = false
            },
            //新增字段
            async addCustom() {
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    if(this.addListForm.dictionary[0] == 'undefined'){
                        this.addListForm.dictionary = ''
                    }
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        table_id:this.MyData.table_id,
                        field_name:this.addListForm.field_name,
                        parent_field:this.addListForm.parent_field,
                        label:this.addListForm.label,
                        field_type:this.addListForm.field_type,
                        group_id:this.addListForm.group_id,
                        array_date:this.addListForm.array_date,
                        array_product:this.addListForm.array_product,
                        array_dept:this.addListForm.array_dept,
                        data_type:this.addListForm.data_type,
                        input_type:this.addListForm.input_type,
                        dictionary:this.addListForm.dictionary,
                        multiple:this.addListForm.multiple ? 'T':'F',
                        mandatory:this.addListForm.mandatory ? 'T':'F',
                        readonly:this.addListForm.readonly ? 'T':'F',
                        hidden:this.addListForm.hidden ? 'T':'F',
                        sort:this.addListForm.sort,
                        comments:this.addListForm.comments,
                        status:this.addListForm.status ? 'ACTIVE':'INACTIVE'
                    }
                    console.log(data)

                    await http.post('/wapi/v1/addCustom', data).then(res => {

                        loading.close()
                        if (res.success){
                            this.dialogFormVisible3 = false
                            this.addListForm.status = true
                            // this.getcustomList(this.MyData)
                            this.getFieldsList()
                            Message({
                                type: 'success',
                                message: '保存成功'
                            });
                        }else {
                            Message.error('保存失败');

                        }
                    })

                } catch (err) {
                    loading.close()
                    console.log(`error:${err}`)
                }
            },


            //获取数字字典
            async getDictionaryLibrary() {

                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id:user.tenant_id
                    }
                    await http.post('/wapi/v1/getDictionaryOptionList', data).then(res => {
                        if (res.success){
                            this.dictionaryList.length = 0
                            // for(var i=0;i<res.data.length;i++){
                            //     this.dictionaryList.push({
                            //         category:res.data[i].category,
                            //         name:res.data[i].name})
                            // }
                            this.dictionaryList = res.data
                        }
                    })

                } catch (err) {
                    loading.close();
                    console.log(`error:${err}`)
                }
            },
            //获取目录
            async getLibrary() {

                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id:user.tenant_id
                    }
                    this.data = [{define_id:2000,label:'自定义',children:[]}]
                    await http.post('/wapi/v1/getcustomDefineList', data).then(res => {

                        loading.close();
                        // this.$nextTick(() => { this.$refs.tree.setCurrentKey(this.treeKey)})
                        setTimeout(() => { this.$refs.tree.setCurrentKey(this.treeKey)},100)
                        if (res.success){
                            for (let i=0;i<res.data.length;i++){
                                if (res.data[i].tenant_id === 'retaium' ){

                                } else {
                                    this.data[0].children.push(res.data[i])
                                }
                            }
                            // this.data=res.data
                            if(this.data[1].children.length == 0){
                                this.data.splice(1,1)
                            }

                        }
                    })

                } catch (err) {
                    loading.close();
                    console.log(`error:${err}`)
                }
            },





            //新增字典保存按钮
            //树状列表
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },

            //新建字典弹框
            open3() {
                this.dialogFormVisible=true
                this.addTableForm={
                    table_name:'',
                        table_type:'',
                        status:true,
                        comments:''
                }
                this.$refs['ruleForm1'].resetFields();
            },
            //编辑字典弹框
            open4() {
                if(this.updataActive){
                    this.stateNum=this.len
                    this.dialogFormVisible2=true
                }
            },
            uploadGroupList(item){
                console.log(item)

                this.uploadGroupForm.group_name = item.group_name
                this.uploadGroupForm.group_id = item.group_id
                this.uploadGroupForm.sort = item.sort
                this.uploadGroupForm.comments =item.comments
                this.uploadGroupForm.status =item.status
                this.uploadGroupoptions = true
            },
            //添加列表弹框
            addListOpen(item) {
                console.log(item)
                this.isShowAddressInfo = true
                this.superior_field = '';
                // this.getcustomList(this.MyData)
                this.dialogFormVisible3=true
                this.addListForm={
                    array_date:'NONE',
                    array_product:'NONE',
                    array_dept:'NONE',
                    field_name:'',
                    parent_field:'',
                    label:'',
                    field_type:'VIRTUAL',
                    data_type:'',
                    input_type:'',
                    dictionary:'',
                    multiple:false,
                    mandatory:false,
                    readonly:false,
                    hidden:false,
                    comments:'',
                    status:true,
                    group_id:item.group_id,

                }
                if(item.fieldsList.length>0){
                    this.addListForm.sort=item.fieldsList[item.fieldsList.length - 1].sort + 1
                }else{
                    this.addListForm.sort = 1
                }

                this.$refs['ruleForm3'].resetFields();
            },

            //编辑按钮
            myDetails(index, row){
                this.isShowAddress = true
                console.log(row)

                let obj={}
                this.superior_field = row.field_name
                obj.tenant_id = row.tenant_id
                obj.table_id = row.table_id
                obj.field_id = row.field_id
                obj.field_name = row.field_name
                obj.parent_field = row.parent_field
                obj.label = row.label
                obj.field_type = row.field_type
                obj.group_id = row.group_id
                obj.array_date = row.array_date
                obj.array_product = row.array_product
                obj.array_dept = row.array_dept
                obj.data_type = row.data_type
                obj.input_type = row.input_type
                obj.dictionary = row.dictionary
                obj.sort=row.sort
                obj.comments=row.comments
                obj.status=row.status==='ACTIVE'?true:false
                obj.multiple=row.multiple==='T'?true:false
                obj.mandatory=row.mandatory==='T'?true:false
                obj.readonly=row.readonly==='T'?true:false
                obj.hidden=row.hidden==='T'?true:false

                this.updataListForm=JSON.parse(JSON.stringify(obj))

                this.dialogFormVisible4=true
                this.$refs['ruleForm4'].resetFields();
                // this.getcustomList(this.MyData)
            },
            //取消清空说明
            abolish(){
                this.dialogFormVisible = false
            },
            //取消清空字段名称
            abolish1(){
                this.isShowAddressInfo = false
                this.dialogFormVisible3 = false
                this.addListForm={
                    array_date:'',
                    array_product:'',
                    array_dept:'',
                    field_name:'',
                    parent_field:'',
                    label:'',
                    field_type:'',
                    data_type:'',
                    input_type:'',
                    dictionary:'',
                    multiple:false,
                    mandatory:false,
                    readonly:false,
                    hidden:false,
                    sort:'',
                    comments:'',
                    status:true
                }
            },
            abolish2(){
                this.isShowAddress = false
                this.dialogFormVisible4 = false
            },
            //添加说明
            addExplain(form){
                this.stateNum++
                if(this.stateNum<=8){
                    this.$set(form,'value'+this.stateNum,'')
                }
            },//添加选项字段
            addOptions(form){
                this.optionsNum++
                if(this.optionsNum<=8){
                    this.$set(form,'value'+this.optionsNum,'')
                }
            },
            //判断文本框类型
            judgeType(key){
                if(key==='name'){
                    return 'input'
                }else if(key==='category'){
                    return 'input'
                }else{
                    return 'textarea'
                }
            },

            onOff(key){
                return  parseInt(key.replace('value',''))-1

            },
            //点击行
            myRowClick(row){

                if (row){
                    // this.form.user_id=row.user_id
                    this.radio=parseInt(row.rowIndex)
                    this.myStatus=row.status==="ACTIVE"?'在职':'离职'

                    if(row.zhuGuan==='STAFF'){
                        this.myZhuGuan='否'
                        this.form.zhuGuan=false
                    }else if(row.zhuGuan==='MANAGER'){
                        this.myZhuGuan='是'
                        this.form.zhuGuan=true
                    }
                    this.tabActive=true
                    this.tableDataRow=row
                }

            },

            handleNodeClick(data,node,ele) {
                this.group_id = ''
                if (data.label === '系统内置' || data.label === '自定义') {
                    this.addUserDis = true
                    return;
                }else {

                    this.addGrp = true
                    this.table_id = data.table_id
                    this.addGroupForm.table_id = data.table_id
                    this.addGroupForm.table_name = data.table_name
                    this.uploadGroupForm.table_id = data.table_id
                    this.uploadGroupForm.table_name = data.table_name
                    this.getGroupList()
                    this.openOff = false
                    this.treeKey = node.key
                    this.define_id = data.define_id
                    this.MyData = data
                    console.log(data)
                    // this.getcustomList(data)
                    this.getDictionaryLibrary()
                    this.myactive2 = false
                    this.myactive1 = true
                    this.schTitle1 = data.label
                    //禁用状态
                    this.updataActive = true
                    //编辑字典
                    this.compileDic.define_id = data.define_id
                    this.compileDic.old_category = data.category
                    this.compileDic.tenant_id = data.tenant_id
                    this.compileDic.category = data.category
                    this.upForm.category = data.category
                    this.upForm.name = data.name
                    if (data.status === 'ACTIVE'){
                        this.upForm.status = true
                    } else {
                        this.upForm.status = false
                    }

                    for (let key in this.upForm) {
                        if (key.indexOf('value') !== -1) {
                            this.$delete(this.upForm, key)
                        }
                    }
                    this.len = 0
                    this.valueArr = []
                    for (let key in data) {
                        if (key.indexOf('value') !== -1) {
                            if (data[key]) {
                                this.$set(this.upForm, key, data[key])
                                this.valueArr.push(data[key])
                                this.len++
                            }
                        }
                    }
                    //禁用状态
                    if (data.onlyread === 'T') {
                        this.updataActive = false
                    } else {
                        this.updataActive = true
                    }

                }
            },

        },
        updated() {
            console.log(this.form)
        }

    };
</script>

<style>
    /*#custom{*/
    /*    overflow: auto;*/
    /*}*/
    /*限制文字长度*/
    #custom .el-tree-node__content span{
        max-width: 240px;

        overflow: hidden;
        margin-left: 10px;
        color: #bbbbbb;
        text-overflow: ellipsis;
        font-size: 12px;
        white-space: nowrap;
    }
    #custom .el-tree-node__expand-icon{
        display: none;
    }
    #custom .el-tree-node__content{
        /*display: flex;*/
        /*justify-content: space-between;*/
        height: 40px;
    }
    #custom .el-tree-node.is-expanded.is-focusable > .el-tree-node__content{
        /*background: #f6f7fa;*/
    }
    #custom .filter-tree .el-tree-node__children > .el-tree-node > .el-tree-node__content:before{
        content: "";
        display: inline-block;
        background: url("../../../assets/images/diction.png") no-repeat;
        background-size:16px ;
        width: 16px;
        height: 16px;
        margin: 20px;
    }
    #custom .filter-tree .el-tree-node__children > .el-tree-node > .el-tree-node__content span{
        margin-left: 0;
        font-size: 16px;
        max-width: 300px;
        color: #606266;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    /*输入框背景*/
    #custom .sWei .el-input__inner{
        background: #eee;
    }
    #custom .StoCen{
        background: white;
        height: auto;
        padding: 0 15px;
    }
    /*.el-main{
      padding: 0;
    }*/
    #custom{
        display: flex;
        justify-content: center;
        height: 100%;
    }
    #custom .el-input__inner::-webkit-input-placeholder {
        text-align: left;
    }
    #custom .el-form-item__label{
        font-size:14px;
        color: black;
        font-weight: bold;
        text-align: left;
    }
    #custom #add .el-form-item__label{
        font-size:14px;
        color: black;
        font-weight: bold;
        text-align: left;
    }
    #custom .StoW .el-form-item__label{
        font-size:14px;
        color: black;
        font-weight: bold;
        text-align: left;
    }
    #custom .el-row {
        margin-bottom: 12px;
    }
    #custom .xux {
        border-bottom: 2px dashed #eee;
        height: 10px;
    }
    #custom .butC {
        padding: 8px 10px;
        margin-top: 26px;
    }
    #custom .tally {
        border: 2px solid rgb(29, 170, 252);
        height: 100%;
        width: 110px;
        margin: 0 10px;
        padding: 0 5px;
        color: rgb(29, 170, 252);
    }
    #custom .tally:nth-of-type(2) {
        border-color: rgb(30, 255, 79);
        color: rgb(30, 255, 79);
    }
    #custom .tally:nth-of-type(3) {
        border-color: rgb(255, 203, 30);
        color: rgb(255, 203, 30);
    }
    #custom .tally:nth-of-type(4) {
        border-color: rgb(255, 30, 244);
        color: rgb(255, 30, 244);
    }
    #custom .tallyBox {
        height: 60px;
        display: flex;
        margin-bottom: 10px;
        justify-content: flex-end;
    }
    #custom .tally .el-row {
        margin: 0;
        font-size: 12px;
        height: 25px;
    }
    #custom .tally .el-row:nth-of-type(2) {
        text-align: center;
        font-size: 20px;
    }
    #custom .cell{
        text-align: left;
    }
    #custom .el-dialog__header {
        border-bottom: 2px dashed #DCDFE6;
        padding: 20px 0 20px 0;
        margin: 20px 20px 10px;
    }
    #custom .el-dialog__close{
        display: none;
    }
    #custom .custom_table_cell {
        color: #2b92fa !important;
    }
    #custom .custom_star label:after{
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
    .dialog-footer {
        margin-top: 10px;
    }
    #el-button span{
        font-weight: bold;
    }
    #addGroup .el-form-item__label{
        font-size:14px;
        color: black;
        font-weight: bold;
        text-align: left;
    }
    #custom .el-dialog__body{
        padding-top: 10px;
    }
    #uploadGroup  .el-form-item__label{
        font-size:14px;
        color: black;
        font-weight: bold;
        text-align: left;
    }
</style>




// WEBPACK FOOTER //
// src/pages/develop/components/custom.vue